export default {
  nav: {
    home: 'Startseite',
    spreadsheet: 'CSSBuy Spreadsheet',
    guides: 'Guides',
    review: 'Review',
    shipping: 'Versand',
    qc: 'QC',
    warehouse: 'Lager',
    safety: 'Sicherheit',
    faq: 'FAQ',
    shoppingGuide: 'Einkaufsführer',
    categories: 'Kategorien',
    language: 'Sprache',
    pt: 'Português',
    de: 'Deutsch',
    en: 'English',
  },
  hero: {
    title: 'CSSBuy Spreadsheet: Produkte, Links und CSSBuy Guides an einem Ort',
    subtitle: 'Finden und organisieren Sie Informationen über Produkte, Links, QC, Versand, Lager und Einkäufe mit unserem unabhängigen CSSBuy Spreadsheet Guide. Recherchieren Sie besser, vergleichen Sie Optionen und treffen Sie fundierte Entscheidungen vor dem Kauf.',
    ctaSpreadsheet: 'CSSBuy Spreadsheet erkunden',
    ctaGuides: 'CSSBuy Guides ansehen',
    ctaMain: 'Hauptseite besuchen',
    ctaBuy: 'Buy It Now',
  },
  categories: {
    title: 'Beliebte Kategorien erkunden',
    subtitle: 'Durchsuchen Sie die meistgesuchten Kategorien und finden Sie schneller, was Sie brauchen.',
    dropdownLabel: 'Kategorie auswählen',
    dropdownPlaceholder: 'Kategorie wählen...',
    shoes: 'Schuhe',
    hoodies: 'Hoodies / Sweater',
    tshirts: 'T-Shirts',
    jackets: 'Jacken',
    pants: 'Hosen / Shorts',
    headwear: 'Kopfbedeckung',
    sets: 'Sets',
    underwear: 'Unterwäsche',
    jersey: 'Jersey',
    accessories: 'Accessoires',
    bags: 'Taschen',
    belts: 'Gürtel',
    perfumes: 'Parfums',
    other: 'Sonstiges',
    cta: 'Spreadsheet ansehen →',
  },
  trust: {
    independent: 'Unabhängiger Guide',
    updated: 'Aktueller Inhalt',
    multilingual: 'Mehrsprachig',
    safety: 'Fokus auf Sicherheit',
  },
  whatIs: {
    title: 'Was ist ein CSSBuy Spreadsheet?',
    intro: 'Ein CSSBuy Spreadsheet ist ein Organisationswerkzeug, das Informationen über Produkte, Links, Kategorien und CSSBuy-Ressourcen zusammenfasst. Es hilft Käufern bei der Recherche, dem Vergleich und der effizienten Suche.',
    point1: 'Organisieren Sie Produkte nach Kategorie für schnellere Recherche',
    point2: 'Vergleichen Sie Links und Optionen vor der Entscheidung',
    point3: 'Überprüfen Sie QC-, Versand- und Lagerinformationen',
    point4: 'Treffen Sie fundierte Entscheidungen mit organisierten Daten',
    cta: 'Vollständigen Guide lesen',
  },
  howItWorks: {
    title: 'So funktioniert es',
    step1: 'Finden',
    step1Desc: 'Durchsuchen Sie Kategorien und finden Sie relevante Produkte im Spreadsheet.',
    step2: 'Vergleichen',
    step2Desc: 'Vergleichen Sie Links, Preise und verfügbare Optionen.',
    step3: 'QC prüfen',
    step3Desc: 'Prüfen Sie QC-Fotos und Bewertungen, wenn verfügbar.',
    step4: 'Versand analysieren',
    step4Desc: 'Verstehen Sie Kosten und Versandoptionen für Ihr Land.',
    step5: 'Entscheiden',
    step5Desc: 'Treffen Sie eine fundierte Entscheidung mit allen organisierten Informationen.',
  },
  guides: {
    title: 'Ausgewählte Guides',
    spreadsheetGuide: 'CSSBuy Spreadsheet Guide',
    spreadsheetGuideDesc: 'Lernen Sie, das CSSBuy Spreadsheet effizient für Produktrecherche und Organisation zu nutzen.',
    reviewGuide: 'CSSBuy Review 2026',
    reviewGuideDesc: 'Unabhängige Analyse von CSSBuy: Funktionen, Versand, Lager und Sicherheit.',
    shippingGuide: 'CSSBuy Shipping Cost',
    shippingGuideDesc: 'Kompletter Guide zu Versandkosten, Optionen und Berechnungen pro Land.',
    qcGuide: 'CSSBuy QC Guide',
    qcGuideDesc: 'Wie man QC-Fotos interpretiert und Produktqualität vor dem Versand prüft.',
    readMore: 'Mehr lesen',
  },
  pillars: {
    title: 'Wichtige CSSBuy Artikel',
    subtitle: 'Entdecken Sie unsere vollständigen Guides zu CSSBuy Spreadsheet, Versand, QC, Sicherheit, Lager und mehr.',
    readMore: 'Artikel lesen',
  },
  products: {
    title: 'Produktkatalog',
    subtitle: 'Stöbern Sie in Produkten unseres Partner-Shops und finden Sie genau das, was Sie suchen.',
    buyNow: 'Jetzt kaufen',
    viewAll: 'Alle anzeigen',
  },
  cta: {
    title: 'CSSBuy Spreadsheet',
    subtitle: 'Besuchen Sie unsere Hauptseite, um das vollständige CSSBuy Spreadsheet zu erkunden, Produkte zu finden und sicherer einzukaufen.',
    buttonSpreadsheet: 'CSSBuy Spreadsheet',
    buttonBuy: 'Buy It Now',
    buttonVisit: 'Hauptseite besuchen',
  },
  footer: {
    about: 'Über uns',
    editorial: 'Redaktionsrichtlinien',
    contact: 'Kontakt',
    privacy: 'Datenschutz',
    terms: 'AGB',
    disclaimer: 'Diese Website ist eine unabhängige Informationsressource und nicht die offizielle CSSBuy-Website. Informationen können sich ändern. Überprüfen Sie aktuelle Produkte, Zahlungen, Versand und Kontodaten vor dem Kauf immer über offizielle Kanäle.',
    copyright: '© 2026 cssbuybr.tattoo — Unabhängiger CSSBuy Spreadsheet Guide',
    visitMain: 'Hauptseite besuchen',
  },
  article: {
    title: 'CSSBuy Spreadsheet 2026: Kompletter Guide und Produktlinks',
    metaDesc: 'Kompletter CSSBuy Spreadsheet 2026 Guide: Was ist es, wie wird es genutzt, Kategorien, QC, Versand und Sicherheit. Unabhängige Ressource für fundierte Produktrecherche.',
    breadcrumbHome: 'Startseite',
    breadcrumbArticle: 'CSSBuy Spreadsheet',
    updated: 'Aktualisiert am 26. August 2026',
    author: 'CSSBuy Spreadsheet Redaktionsteam',
    reviewed: 'Von Experten für internationale Einkäufe geprüft',
    quickAnswer: 'Das CSSBuy Spreadsheet ist ein Organisationswerkzeug, das Informationen über Produkte, Links und Ressourcen im Zusammenhang mit CSSBuy zusammenfasst. Es hilft Käufern bei der effizienten Recherche, dem Vergleich und der Produktfinding, indem es Daten nach Kategorie organisiert und schnellen Zugriff auf QC-, Versand- und Lagerinformationen bietet.',
    h1: 'CSSBuy Spreadsheet 2026: Kompletter Guide und Produktlinks',
    h2What: 'Was ist das CSSBuy Spreadsheet?',
    h2WhatP1: 'Das CSSBuy Spreadsheet ist eine organisatorische Ressource, die entwickelt wurde, um Käufern bei der Navigation durch den riesigen Produktkatalog von CSSBuy zu helfen. Es funktioniert als strukturiertes Verzeichnis, in dem Informationen über Produkte, Links, Kategorien und Ressourcen systematisch zusammengestellt werden.',
    h2WhatP2: 'Im Gegensatz zu einer einfachen Linkliste ermöglicht ein gut organisiertes Spreadsheet das Filtern nach Kategorien, den Vergleich von Optionen und den Zugriff auf spezifische Guides für jeden Produkttyp. Das ist besonders nützlich für Einsteiger in internationale Einkäufe, die einen verlässlichen Ausgangspunkt benötigen.',
    h2How: 'Wie man das CSSBuy Spreadsheet nutzt',
    h2HowP1: 'Die Nutzung des CSSBuy Spreadsheet ist ein einfacher Prozess, der Ihre Recherche-Erfahrung transformieren kann. Identifizieren Sie zuerst die gesuchte Produktkategorie — sei es Schuhe, Kleidung, Accessoires oder Elektronik. Navigieren Sie zu dieser Kategorie im Spreadsheet und erkunden Sie die verfügbaren Optionen.',
    h2HowP2: 'Wenn Sie ein interessantes Produkt finden, prüfen Sie die QC-Informationen (Quality Control), wenn verfügbar. QC-Fotos sind essenziell, um die tatsächliche Qualität vor dem Kauf zu bewerten. Achten Sie auch auf Versand- und Lagerinformationen, um Gesamtkosten und Lieferzeit zu verstehen.',
    h2Categories: 'Kategorien des CSSBuy Spreadsheet',
    h2CategoriesP1: 'Das CSSBuy Spreadsheet organisiert Produkte in klare, intuitive Kategorien. Die Hauptkategorien umfassen:',
    catShoes: 'Schuhe und Sneakers — von Casual-Modellen bis zu limitierten Editionen',
    catHoodies: 'Hoodies und Sweater — Winterbekleidung und Streetwear',
    catTshirts: 'T-Shirts — Basic, bedruckt und Sondereditionen',
    catJackets: 'Jacken — Mäntel, Parkas und Windbreaker',
    catPants: 'Hosen und Shorts — Jeans, Cargo, Sport und Casual',
    catAccessories: 'Accessoires — Gürtel, Brillen, Schmuck und diverse Artikel',
    catBags: 'Taschen — Rucksäcke, Geldbörsen, Reisetaschen',
    catPerfumes: 'Parfums — Düfte und Körperpflegeprodukte',
    h2Qc: 'CSSBuy QC: Qualitätskontrolle und Fotos',
    h2QcP1: 'QC (Quality Control) ist eine der wichtigsten Funktionen von CSSBuy. Wenn Sie ein Produkt kaufen, kann der Agent detaillierte Fotos des Artikels machen, bevor er ihn versendet. Das ermöglicht die Prüfung von Qualität, Farbe, Größe und Verarbeitung.',
    h2QcP2: 'QC-Fotos sind besonders wertvoll für Produkte, bei denen Details wichtig sind, wie Schuhe, Markenkleidung und Accessoires. Fordern Sie QC-Fotos an und vergleichen Sie sie mit den Originalbildern des Verkäufers, um Abweichungen zu erkennen.',
    h2Shipping: 'CSSBuy Shipping Cost: Versandkosten',
    h2ShippingP1: 'Die Versandkosten bei CSSBuy hängen von mehreren Faktoren ab: Zielland, Paketgewicht, Abmessungen, gewählte Versandmethode und ob Sie zusätzliche Dienste wie Versicherung oder verstärkte Verpackung wählen. Länder wie Deutschland, USA, Großbritannien und Brasilien haben unterschiedliche Optionen mit variierenden Kosten.',
    h2ShippingP2: 'Vor Abschluss eines Kaufs ist es wichtig, die Gesamtkosten zu kalkulieren — Produkt, Agent-Gebühren, Versand und mögliche Einfuhrsteuern. Nutzen Sie das Spreadsheet, um verschiedene Szenarien zu vergleichen und die wirtschaftlichste Option für Ihre Situation zu wählen.',
    h2Safety: 'CSSBuy Safety: Sicherheit und Vorsicht',
    h2SafetyP1: 'Sicherheit ist Priorität bei der Nutzung internationaler Einkaufsservices. Prüfen Sie immer, ob Sie auf der richtigen Website sind, teilen Sie Ihr Passwort nie, bestätigen Sie Preise vor der Zahlung und prüfen Sie QC-Fotos, wenn verfügbar.',
    h2SafetyP2: 'Dieses Spreadsheet ist eine unabhängige Informationsressource. Es garantiert keine Produktqualität, ist keine offizielle Zertifizierung und ersetzt nicht Ihre eigene Recherche. Überprüfen Sie aktuelle Informationen immer über offizielle Kanäle vor dem Kauf.',
    h2Table: 'CSSBuy Spreadsheet vs Normale Suche',
    feature: 'Funktion',
    spreadsheet: 'CSSBuy Spreadsheet',
    normalSearch: 'Normale Suche',
    prodDiscovery: 'Produktentdeckung',
    prodDiscoveryS: 'Einfach und organisiert',
    prodDiscoveryN: 'Mittel',
    organization: 'Organisation',
    organizationS: 'Hoch',
    organizationN: 'Niedrig',
    categorySearch: 'Kategorische Suche',
    categorySearchS: 'Ja',
    categorySearchN: 'Variabel',
    qcRef: 'QC-Referenz',
    qcRefS: 'Verfügbar wenn bereitgestellt',
    qcRefN: 'Variabel',
    beginnerFriendly: 'Anfängerfreundlich',
    beginnerFriendlyS: 'Hoch',
    beginnerFriendlyN: 'Mittel',
    h2Faq: 'Häufig gestellte Fragen (FAQ)',
    faq1Q: 'Ist das CSSBuy Spreadsheet offiziell?',
    faq1A: 'Nein. Dies ist eine unabhängige Informationsressource. Wir sind keine offiziellen CSSBuy-Partner und vertreten nicht das Unternehmen. Unser Ziel ist die Bereitstellung von Guides und Informationsorganisation für Ihre Recherche.',
    faq2Q: 'Wie greife ich auf das CSSBuy Spreadsheet zu?',
    faq2A: 'Sie können über unsere Hauptseite auf das CSSBuy Spreadsheet zugreifen. Durchsuchen Sie Kategorien, erkunden Sie Produkte und folgen Sie den Links für mehr Informationen.',
    faq3Q: 'Garantiert das Spreadsheet Produktqualität?',
    faq3A: 'Nein. Das Spreadsheet organisiert Informationen, garantiert aber keine Qualität, Authentizität oder Verfügbarkeit. Prüfen Sie immer QC-Fotos, Preise und Versandinformationen vor dem Kauf.',
    faq4Q: 'Welche Kategorien sind verfügbar?',
    faq4A: 'Die Kategorien umfassen Schuhe, Hoodies, T-Shirts, Jacken, Hosen, Taschen, Accessoires, Parfums, Gürtel, Kopfbedeckung, Sets, Unterwäsche, Jersey und andere Produkte.',
    faq5Q: 'Ist CSSBuy sicher?',
    faq5A: 'CSSBuy ist eine bekannte Plattform, aber wie jeder Online-Service erfordert sie Vorsicht. Prüfen Sie URLs, schützen Sie Ihr Konto, bestätigen Sie Preise und nutzen Sie QC-Fotos zur Produktverifizierung.',
    ctaMain: 'Hauptseite besuchen',
    ctaSpreadsheet: 'CSSBuy Spreadsheet erkunden',
    ctaSafety: 'Sicherheitsguide lesen',
    tipLabel: 'CSSBuy Spreadsheet Tipp',
    tipText: 'Nutzen Sie das Spreadsheet, um mehrere Produkte vor der Entscheidung zu vergleichen. Kreuzen Sie QC-Fotos, Versandkosten und Verkäuferinformationen für das beste Ergebnis.',
    bottomCtaText: 'Erkunden Sie das CSSBuy Spreadsheet auf der Hauptseite und finden Sie die Produkte, die Sie suchen.',
    sidebarCtaText: 'Greifen Sie über die Hauptseite auf das vollständige Spreadsheet zu.',
    sidebarCategories: 'Kategorien',
    toc: 'Inhalt',
    tocWhat: 'Was ist es?',
    tocHow: 'Wie nutzen',
    tocCategories: 'Kategorien',
    tocQc: 'QC und Fotos',
    tocShipping: 'Versandkosten',
    tocSafety: 'Sicherheit',
    tocTable: 'Vergleich',
    tocFaq: 'FAQ',
  },
  notFound: {
    message: 'Seite nicht gefunden. Gehen Sie zurück zur Startseite und erkunden Sie das CSSBuy Spreadsheet.',
  },
};